import { OnboardingFormController } from "../controller/OnboardingFormController";
import { Route, Switch } from 'react-router-dom';
import { Routes as RoutePaths } from "./Common/Constants";
import MobileDialog from "./Layout/Wrappers/MobileDialog";
import { CheckEligibilityIntro, EnglishTestsQuestion, GraduateTestsQuestion, HighestEducationQuestion, NationalityQuestion, OverallGradeQuestion, ProvinceOfResidence } from "./Pages";
import { ProgressBarProvider } from "./Providers";
import Results from "./Common/Results";
import RestartProgress from "./Common/RestartProgress";
import React from 'react';
import { AdvisorConfirmationPage, PathwayPage } from "../ApplyBoost/Pages";
export function CheckEligibilityRoutes(props) {
  return /*#__PURE__*/React.createElement(OnboardingFormController, {
    onExit: props.onExit
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: RoutePaths.Eligibility.CheckEligibilityIntro
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(CheckEligibilityIntro, {
    onExit: props.onExit
  }))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Eligibility.NationalityQuestion
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 0
  }, /*#__PURE__*/React.createElement(NationalityQuestion, {
    onExit: props.onExit,
    onSave: props.onSave
  })))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Eligibility.ProvinceOfResidenceQuestion
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 17
  }, /*#__PURE__*/React.createElement(ProvinceOfResidence, {
    onExit: props.onExit,
    onSave: props.onSave
  })))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Eligibility.HighestEducationQuestion
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 34
  }, /*#__PURE__*/React.createElement(HighestEducationQuestion, {
    onExit: props.onExit,
    onSave: props.onSave
  })))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Eligibility.OverallGradeQuestion
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 51
  }, /*#__PURE__*/React.createElement(OverallGradeQuestion, {
    onExit: props.onExit,
    onSave: props.onSave
  })))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Eligibility.EnglishTestsQuestion
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 68
  }, /*#__PURE__*/React.createElement(EnglishTestsQuestion, {
    onExit: props.onExit,
    onSave: props.onSave
  })))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Eligibility.GraduateTestsQuestion
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 85
  }, /*#__PURE__*/React.createElement(GraduateTestsQuestion, {
    onExit: props.onExit,
    onSave: props.onSave
  })))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.ApplyBoost.PathwayPage
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(ProgressBarProvider, {
    completion: 100
  }, /*#__PURE__*/React.createElement(PathwayPage, null)))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.ApplyBoost.AdvisorConfirmationPage
  }, /*#__PURE__*/React.createElement(MobileDialog, {
    stickyButton: true
  }, /*#__PURE__*/React.createElement(AdvisorConfirmationPage, null))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.Results
  }, /*#__PURE__*/React.createElement(MobileDialog, null, /*#__PURE__*/React.createElement(Results, {
    onExit: props.onExit
  }))), /*#__PURE__*/React.createElement(Route, {
    path: RoutePaths.RestartProgress
  }, /*#__PURE__*/React.createElement(MobileDialog, null, /*#__PURE__*/React.createElement(RestartProgress, {
    onExit: props.onExit
  })))));
}